import type { NotificationReportsProps } from '@/utils/hooks/context/toast/types';

// Components
import ReportReady from '@/components/composite/Notifications/Reports/ReportReady';

const NotificationsReports = ({ notification }: NotificationReportsProps) => {
    const type = notification.type;
    switch (type) {
        case 'pending_report_ready':
            return <ReportReady notification={notification} />;
        default:
            return null;
    }
};

export default NotificationsReports;
